import { useState, useEffect } from "react";
import countryCodeToName from "../../../../../const/countryCodeToName";
import { initialErrors, initialGuestInfo } from "../../const";

export const useGuestInformation = (guestNationalityRef) => {
  const [errors, setErrors] = useState(initialErrors);
  const [guestInfo, setGuestInfo] = useState(initialGuestInfo);
  const [isValidEmail, setIsValidEmail] = useState(true);

  useEffect(() => {
    if (guestInfo.guestEmail) {
      const isValid = /\S+@\S+\.\S+/.test(guestInfo.guestEmail);
      setIsValidEmail(isValid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestInfo]);

  const validateEmail = () => {
    const { guestEmail, confirmGuestEmail } = guestInfo;
    if (guestEmail !== confirmGuestEmail) {
      setErrors((prev) => ({ ...prev, email: "Emails do not match!" }));
    } else {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  const validatePhoneNumber = () => {
    const { guestPhoneNumber, confirmGuestPhoneNumber } = guestInfo;
    if (guestPhoneNumber !== confirmGuestPhoneNumber) {
      setErrors((prev) => ({ ...prev, phone: "Phone numbers do not match!" }));
    } else {
      setErrors((prev) => ({ ...prev, phone: "" }));
    }
  };

  const handleNationalityChange = (code) => {
    setGuestInfo((prev) => ({
      ...prev,
      guestNationality: code,
    })); // Update state for UI
    guestNationalityRef.current = countryCodeToName[code]; // Save full country name
  };

  return {
    isValidEmail,
    validateEmail,
    validatePhoneNumber,
    errors,
    guestInfo,
    setGuestInfo,
    handleNationalityChange,
  };
};
